// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { Label, Input } from "../../revvComponents";

// Components Imports

const CheckBoxRenderer = props => (
  <Label htmlFor="grid-checkbox-renderer">
    <Input
      id="grid-checkbox-renderer"
      type="checkbox"
      value=""
      checked={props.value}
      readOnly
    />
  </Label>
);

CheckBoxRenderer.defaultProps = {
  value: false,
};

CheckBoxRenderer.propTypes = {
  // Props
  value: PropTypes.bool,
};
export default CheckBoxRenderer;
